import React from "react"
import { Link } from "gatsby"
import IconTitleBarBackChevron from "../icons/iconTitleBarBackChevron.svg"

function BackButton(props) {
  return (
    <Link to={props.backLink} className="titleBarBackButton">
      <IconTitleBarBackChevron className="backIcon"/>
      <div className="backTitle">{props.backTitle}</div>
    </Link>
  )
}

function BarActions(props) {
  const { actions } = props
  switch(actions) {
    case '':
      return null
    default:
      return (
        <div className="titleBarActions">
          {props.actions}
        </div>
      )
  }
}

export default function TitleBar(props) {
  const { type } = props
  switch(type) {
    case 'detail':
      return (
        <div className="titleBar detailBar">
          <div className="titleBarContent">
            <BackButton backLink={props.backLink} backTitle={props.backTitle}/>
            
            <h1 className="titleBarTitle">{props.title}</h1>

            <BarActions actions={props.actions} />
          </div>

          <div className="separator" />
        </div>
      )
    case 'main':
      return (
        <div className="titleBar">
          <div className="titleBarContent">
            <h1 className="titleBarTitle">{props.title}</h1>
            <BarActions actions={props.actions} />
          </div>
          
          <div className="separator" />
        </div>
      )
    default:
      return (
        <div className="titleBar">
          <div className="titleBarContent">
            <h1 className="titleBarTitle">{props.title}</h1>
            <BarActions actions={props.actions} />
          </div>
          
          <div className="separator" />
        </div>
      )
  }
}